// extracted by mini-css-extract-plugin
export default {"addSchool":"AddSchool_addSchool__XC6Lm","addSchool__header":"AddSchool_addSchool__header__I5fAf","addSchool__header__close":"AddSchool_addSchool__header__close__BMI-y"};